module.exports = __webpack_public_path__ + "img/articulos1.47fef4ef.png";